import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SessionTimeoutService } from './session-timeout.service';

import { entraAuthService } from './auth.service';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(
    private msalService: MsalService,
    private sessionTimeoutService: SessionTimeoutService,
    private entraAuthService: entraAuthService
  ) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      if (!this.sessionTimeoutService.checkSession()) {
        return false;
      }
      return true;
    } else {
      localStorage.setItem('redirect_url', state.url);
      await this.entraAuthService.initLogin();
      return false;
    }
  }
}
